import { useEffect } from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Skeleton } from '@albo-ui/core';
import { TextField, Select, MenuItem } from '@mui/material';
import { useRewardsFilter } from "./hooks/useRewardsFilter";
import { rewardsLevelType, rewardsTxType } from '../../../util/DataObject';

export type FilterRewardsDialogProps = {
    onConfirm: (data) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    catalog: any;
    tabActive: string;
} & DefaultComponentProps;

export const FilterRewards = ({ open, title, catalog, tabActive, onConfirm, onClose }: FilterRewardsDialogProps) => {
    const { onHandleChange, form, loader } = useRewardsFilter(open, tabActive)

    useEffect(() => {}, [loader])

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>
            {loader ? 
                <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                :  
                <DialogContent>
                {tabActive === "promotions" || tabActive === "history_promo" ?
					<FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
                        <FlexGrid container fullWidth>
                            <Select MenuProps={{style: {zIndex: 35001}}} value={form["description"] || -1} onChange={onHandleChange.bind(this, "description" , "")} color='secondary' fullWidth>
                                <MenuItem value={-1} disabled>Tipo de Operación</MenuItem>
                                {catalog && catalog.map((t) => {
                                    return <MenuItem key={t.k} value={t.m[0]["acumulator_description"]}>{t.v}</MenuItem>
                                })}
                            </Select>
                        </FlexGrid>
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form["period"] && (form["period"]["sdate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "sdate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1, cursor: "pointer" }} color="secondary" label="Vigencia - Inicio" />
							<TextField value={form["period"] && (form["period"]["edate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "edate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1 }} color="secondary" label="Vigencia - Fin" />
						</FlexGrid>
						<FlexGrid container spacing={2} fullWidth>
                            <Select MenuProps={{style: {zIndex: 35001}}} value={form["status"] || -1} onChange={onHandleChange.bind(this, "status" , "")} color='secondary' fullWidth>
                                <MenuItem value={-1} disabled>Estatus</MenuItem>
                                <MenuItem value={"enabled"}>Habilitado</MenuItem>
                                <MenuItem value={"disabled"}>Deshabilitado</MenuItem>
                            </Select>
							<TextField value={form["multiplier"]} onInput={onHandleChange.bind(this, "multiplier", "")} label="Multiplicador" color="secondary" fullWidth/>
						</FlexGrid>
					</FlexGrid>
					:
					<FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
						<FlexGrid container spacing={2} fullWidth>
                            <Select MenuProps={{style: {zIndex: 35001}}} value={form["level_uuid"] || -1} onChange={onHandleChange.bind(this, "level_uuid" , "")} color='secondary' fullWidth>
                                <MenuItem value={-1} disabled>Nivel</MenuItem>
                                {rewardsLevelType && rewardsLevelType.map((t) => {
                                    return <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
                                })}
							</Select>
							<TextField value={form["priority"]} onInput={onHandleChange.bind(this, "priority", "")} label="Prioridad" color="secondary" fullWidth/>
						</FlexGrid>
						<FlexGrid container spacing={2} fullWidth>
                            <Select MenuProps={{style: {zIndex: 35001}}} value={form["type"] || -1} onChange={onHandleChange.bind(this, "coupons", "type")} color='secondary' fullWidth>
                                <MenuItem value={'-1'} disabled>Tipo de Cupón</MenuItem>
                                {rewardsTxType.map((t) => {
                                    return <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
                                })}
                            </Select>
                            <Select MenuProps={{style: {zIndex: 35001}}} value={(form["coupons"] && String(form["coupons"]["active"])) || -1} onChange={onHandleChange.bind(this, "coupons", "active")} color='secondary' fullWidth>
                                <MenuItem value={-1} disabled>Estado del Cupón</MenuItem>
                                <MenuItem value={"true"}>Activo</MenuItem>
                                <MenuItem value={"false"}>Inactivo</MenuItem>
                            </Select>
						</FlexGrid>

						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form["period"] && (form["period"]["sdate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "sdate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1, cursor: "pointer" }} color="secondary" label="Vigencia - Inicio" />
							<TextField value={form["period"] && (form["period"]["edate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "edate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1 }} color="secondary" label="Vigencia - Fin" />
						</FlexGrid>
					</FlexGrid>
				}
                </DialogContent>
            }
            <DialogActions>
                <FlexGrid fullHeight fullWidth container spacing={2} justify='space-between' style={{ marginTop: '20px'}}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={() => onConfirm(form)} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}